import React, { useState } from 'react';

import { 
    Grid, 
    Container,
    Button,
    Dialog,
    DialogContent,
    DialogActions,
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
    Divider,
    Typography
} from '@material-ui/core/';
import { toast } from 'react-toastify';
import CloseIcon from '@material-ui/icons/Close';
import Star from '@material-ui/icons/Star';
import Check from '@material-ui/icons/Check';
import SeatPicker from 'react-seat-picker';

import { Content, ContainerBox } from './styles';
import Label from '../../../components/Label';
import EventApi from '../../../services/event';
import Btn from '../../../components/Button'

const SearchResult = (props) => {
    const [dialogOpen, setDialogOpen] = useState(false);
    const [person, setPerson] = useState({});
    const [status, setStatus] = useState({});
    const [rows, setRows] = useState(props.data.rows);
    const [confirmed, setConfirmed] = useState(false);

    const event = props.data.event;
    // console.log(props.data.status.find(e=>{return e?.name === 'SHOWED_UP'}).id)
    console.log(props.data.status);

    const SHOWED_UP_ID = 5//props.data.status.find(e=>{return e?.name === 'SHOWED_UP'}).id || 5;
    
    const onClick = (event, person) => {
        event.preventDefault();
        setPerson(person);
        markPosition(person.position_id);
        console.log(person);
        setStatus(props.data.status.find(e => { return e?.name === 'SHOWED_UP' }));
        console.log(status);
        setDialogOpen(true);
    }

    const handleClose = () => { 
        setDialogOpen(false);
        setRows(props.data.rows);
    };

    const updatePerson = (event, newStatus) => {
        event.preventDefault();
        EventApi.updatePerson(person.id, {
            ...person,
            status_id: status ? (status.id ? status.id : SHOWED_UP_ID) : SHOWED_UP_ID,
        })
        .then(resp => {
            if (!!resp.data) {
                console.log(resp.data)
                // toast.success('usuário alterado com sucesso!')
                // handleClose();
                // window.location.reload();
                setConfirmed(true);
            }
        })
        .catch(function(error) {
            toast.error(error)
        });
    }

    const handleCloseConfirmed = () => {
        handleClose();
        setConfirmed(false);
        props.close();
    }

    const markPosition = (id) => {
        setRows(rows.map(col => { return col.map(pos => {
            if (pos) {
                if (pos.id === id)
                    return { ...pos, isSelected: true, isReserved: false }
            }
            return pos
        })}))
    }

    const confirmDialog = (
        <>
            <Dialog
                fullScreen
                onClose={handleClose}
                open={dialogOpen}
            >
                <ContainerBox className="content">
                    <DialogContent>
                        <Label
                            size='medium'
                            color='dark'
                            align='center'
                            weight='500'
                            padding='5px 0'
                        >
                            { person.status_id !== SHOWED_UP_ID 
                            ? 'Confirmar Presença?' : 'Presença Confirmada'}
                        </Label>
                        <Grid container alignItems="center" justify="space-around" spacing={2}>
                            <Label>
                                Agraciado:
                            </Label>
                            <Typography>
                                {person.name}
                            </Typography>
                        </Grid>
                    </DialogContent>
                    <Divider/>
                    <Label
                        size='small'
                        color='dark'
                        align='center'
                        font='Roboto'
                        padding='10px 0 30px'
                    >
                        Posição no evento:
                    </Label>
                    <SeatPicker
                        rows={rows}
                        maxReservableSeats={event.lines * event.columns}
                        alpha={false}
                        visible
                        selectedByDefault
                        tooltipProps={{multiline: true}}
                    />
                    <Divider/>
                    <DialogActions>
                        <Btn 
                            onClick={handleClose} 
                            color='error'
                            format='solid'
                            style={{maxWidth:'50%'}}
                        >
                            Cancelar
                        </Btn>
                        { person.status_id !== SHOWED_UP_ID ? (
                            <Btn 
                                onClick={e=>updatePerson(e, 'SHOWED_UP')} 
                                color="dark"
                                format='solid'
                                style={{maxWidth:'50%'}}
                            >
                                Confirmar
                            </Btn>
                        ) : null}
                    </DialogActions>
                </ContainerBox>
            </Dialog>
        </>
    )

    const vip = (
        <ListItemIcon>
            <Star />
        </ListItemIcon>
    )
    const showed = (
        <ListItemIcon>
            <Check />
        </ListItemIcon>
    )

    const confirmedSuccess = (
        <>
            <Dialog
                fullScreen
                onClose={handleCloseConfirmed}
                open={confirmed}
            >
                <ContainerBox className="content">
                    <DialogContent>
                        <Label
                            size='medium'
                            color='dark'
                            align='center'
                            weight='500'
                            padding='5px 0'
                        >
                            Presença Confirmada!
                        </Label>
                        <Divider/>
                        <Grid className="confirmed">
                            <Typography className="text">Seja bem vindo(a) {person.name}</Typography>
                        </Grid>
                    </DialogContent>
                    <DialogActions className="buttons">
                        <Btn 
                            onClick={handleCloseConfirmed} 
                            color='error'
                            format='solid'
                        >
                            Fechar
                        </Btn>
                    </DialogActions>
                </ContainerBox>
            </Dialog>
        </>
    )
    
    const renderResult = () => {
        if (props.data.people.length > 0) {
            return props.data.people.map(person => {
                return (
                    <ListItem 
                        button
                        onClick={(event) => onClick(event, person)}
                        style={{alignItems:"center", justifyContent:"space-between"}}
                    >
                        <ListItemText primary={`${person.name}`} secondary={`${person.role}`} />
                        { person.vip? vip : null }
                        { person.status_id === SHOWED_UP_ID ? showed : null }
                    </ListItem>
                )
            })
        } else {
            return (<Typography style={{textAlign:'center'}}>Nenhum resultado encontrado</Typography>)
        }
        
    }

    return (
        <>
        {confirmDialog}
        {confirmedSuccess}
        <Container component="main" maxWidth="xs" style={{ background: '#ecf1f8' }}>
            <Content>
                <Label
                    size='medium'
                    color='dark'
                    align='center'
                >
                    Resultado
                </Label>
                <List component="nav" style={{ width: '100%' }}>
                    {renderResult()}
                </List>
                <div className="content_button">
                    <Grid container>
                        <Button
                            className="button"
                            variant="contained"
                            color="secondary"
                            disableElevation
                            onClick={() => props.close()}
                        >
                            <CloseIcon />
                        </Button>
                    </Grid>
                </div>
            </Content>
        </Container>
        </>
    )
}

export default SearchResult;
